import guideService from '../../services/guideService'

const state = {
    guide: []
}


const getters = {
    guide: state => {
        return state.guide
    }
}

const actions = {
    getGuide({ commit}, params) {
        guideService.fetchGuide(params)
        .then(guide => {
            commit('setGuide', guide)
        })
    },
    addGuide({commit}, guide) {
        guideService.postGuide(guide).then((response) => {response.data;
             return response
          })
        .then((guide) => {
            commit('addGuide', guide)
            return guide
        })
    },
}

const mutations = {
    setGuide (state, guide) {
        state.guide = guide
    },
    addGuide (state, guide) {
        // let record = state.guide.findIndex(element=> {
        //     return element.id == guide.id
        // })
        // if (record<0){
        //     state.guide.push(guide)
        // }
    },
}

export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}